import { render, staticRenderFns } from "./EventsCalendar.vue?vue&type=template&id=32ea7113&scoped=true"
import script from "./EventsCalendar.vue?vue&type=script&lang=ts"
export * from "./EventsCalendar.vue?vue&type=script&lang=ts"
import style0 from "./EventsCalendar.vue?vue&type=style&index=0&id=32ea7113&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ea7113",
  null
  
)

export default component.exports